// Link na bio: pagina propria do tenant (separada da vitrine), com tema, estilo
// dos botoes, perfil, icones sociais e uma lista ordenada de links livres com
// contagem de cliques. Contrato compartilhado entre painel e Worker SSR.
import { normalizeSocialLinks, safeHttpsUrl } from "./storefront-settings.js";
export const BIO_THEMES = ["claro", "escuro", "areia", "menta", "lavanda"];
export const BIO_THEME_LABELS = {
    claro: "Claro",
    escuro: "Escuro",
    areia: "Areia",
    menta: "Menta",
    lavanda: "Lavanda",
};
export const BIO_THEME_PALETTES = {
    claro: { bg: "#f6f6f4", surface: "#ffffff", text: "#17181a", muted: "#5f646b", border: "#e2e2de", accent: "#17181a", accentInk: "#ffffff" },
    escuro: { bg: "#0f1013", surface: "#1b1d22", text: "#f3f4f6", muted: "#a0a6ae", border: "#2a2d33", accent: "#f3f4f6", accentInk: "#0f1013" },
    areia: { bg: "#f4ecdf", surface: "#fbf6ee", text: "#3b2f20", muted: "#7a6a55", border: "#e3d6c2", accent: "#8a5a2b", accentInk: "#ffffff" },
    menta: { bg: "#e7f6ef", surface: "#f7fcf9", text: "#123b2a", muted: "#4d7464", border: "#cbe8da", accent: "#1f8a5c", accentInk: "#ffffff" },
    lavanda: { bg: "#efeafb", surface: "#faf8ff", text: "#2b2150", muted: "#665c8f", border: "#ddd4f5", accent: "#6b4fd8", accentInk: "#ffffff" },
};
export const BIO_BUTTON_STYLES = ["arredondado", "quadrado", "pilula"];
export const BIO_BUTTON_LABELS = {
    arredondado: "Arredondado",
    quadrado: "Quadrado",
    pilula: "Pílula",
};
/** Raio do botao por estilo (CSS). */
export const BIO_BUTTON_RADIUS = {
    arredondado: "14px",
    quadrado: "2px",
    pilula: "999px",
};
/** Teto de links por pagina. Espelhado na RPC upsert_bio_link. */
export const MAX_BIO_LINKS = 50;
export const MAX_BIO_TITLE = 80;
export const MAX_BIO_DESCRIPTION = 300;
export const MAX_BIO_LINK_TITLE = 80;
export const DEFAULT_BIO_SETTINGS = Object.freeze({
    title: "",
    description: "",
    logoUrl: null,
    theme: "claro",
    buttonStyle: "arredondado",
    socials: Object.freeze({}),
});
function record(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value) ? value : {};
}
function text(value, max) {
    return typeof value === "string" ? value.trim().slice(0, max) : "";
}
/** Normaliza a configuracao crua (colunas de bio_pages) com defaults seguros. */
export function normalizeBioSettings(raw) {
    const r = record(raw);
    return {
        title: text(r["title"], MAX_BIO_TITLE),
        description: text(r["description"], MAX_BIO_DESCRIPTION),
        logoUrl: safeHttpsUrl(r["logoUrl"] ?? r["logo_url"]),
        theme: BIO_THEMES.includes(r["theme"]) ? r["theme"] : DEFAULT_BIO_SETTINGS.theme,
        buttonStyle: BIO_BUTTON_STYLES.includes((r["buttonStyle"] ?? r["button_style"]))
            ? (r["buttonStyle"] ?? r["button_style"])
            : DEFAULT_BIO_SETTINGS.buttonStyle,
        socials: normalizeSocialLinks(r["socials"]),
    };
}
/** Link valido para a pagina: titulo nao vazio e URL https. null = descartar. */
export function normalizeBioLink(raw) {
    const r = record(raw);
    const id = typeof r["id"] === "string" ? r["id"] : null;
    const title = text(r["title"], MAX_BIO_LINK_TITLE);
    const url = safeHttpsUrl(r["url"]);
    if (!id || title.length === 0 || !url)
        return null;
    const position = typeof r["position"] === "number" && Number.isFinite(r["position"]) ? r["position"] : 0;
    const clicks = r["clickCount"] ?? r["click_count"];
    return {
        id,
        title,
        url,
        position,
        isActive: (r["isActive"] ?? r["is_active"]) !== false,
        clickCount: typeof clicks === "number" && clicks > 0 ? Math.floor(clicks) : 0,
    };
}
/** Move o item de `from` para `to` sem mutar a lista (ordenacao por arrastar). */
export function moveItem(items, from, to) {
    if (from < 0 || from >= items.length || to < 0 || to >= items.length || from === to)
        return [...items];
    const next = [...items];
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    return next;
}
//# sourceMappingURL=bio.js.map